/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import MatchInfoCard from '../MatchInfoCard/MatchInfoCard';
import s from './MatchCardInfoSlider.scss';
// eslint-disable-next-line no-unused-vars
import slickcss from '../../../../node_modules/slick-carousel/slick/slick.css';
import Link from '../../../components/Link';

class MatchCardInfoSlider extends React.Component {
  createVenueScheduleSlider = () =>
    this.props.items.map(match => {
      const isLiveMatch =
        match &&
        match.event_status &&
        match.event_status.toLowerCase() === 'play in progress';
      const isUpcomingMatch =
        match &&
        match.event_status &&
        (match.event_status.toLowerCase() === 'match yet to begin' ||
          match.event_status.toLowerCase().includes('match begin'));
      const isMatchEnded =
        match &&
        match.event_status &&
        (match.event_status.toLowerCase() === 'match ended' ||
          match.event_status.toLowerCase() === 'match abandoned' ||
          match?.short_event_status?.toLowerCase() === 'match abandoned');
      return (
        <>
          {isUpcomingMatch ? (
            <div className={s.match_slider_wrapper}>
              <MatchInfoCard
                isLiveMatch={isLiveMatch}
                isUpcomingMatch={isUpcomingMatch}
                isMatchEnded={isMatchEnded}
                data={match}
                seriesname="Schedule"
                isLanding={this.props.isLanding}
              />
            </div>
          ) : (
            <Link to={match?.cardurl} className={s.match_slider_wrapper}>
              <MatchInfoCard
                isLiveMatch={isLiveMatch}
                isUpcomingMatch={isUpcomingMatch}
                isMatchEnded={isMatchEnded}
                data={match}
                seriesname="Schedule"
                isLanding={this.props.isLanding}
              />
            </Link>
          )}
        </>
      );
    });
  render() {
    const settings = {
      slidesToShow: this.props.slideToShow || 2,
      slidesToScroll: 1,
      dots: this.props.dots || false,
      //arrows: true,
      infinite: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1510,
          settings: {
            slidesToShow: this.props.slideToShowSmall
              ? this.props.slideToShowSmall
              : 2.4,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const { isWapView } = this.props;
    if (
      this.props.items &&
      Array.isArray(this.props.items) &&
      this.props.items.length > 0
    ) {
      if (!isWapView) {
        return (
          <Slider
            className={`slick_UI ${
              this.props.slideToShowSmall ? 'dotsHidePointsTable' : ''
            }`}
            {...settings}
          >
            {this.createVenueScheduleSlider()}
          </Slider>
        );
      }
      return (
        <div className={this.props.isLanding ? s.LandingPageslider : ''}>
          {this.createVenueScheduleSlider()}
        </div>
      );
    }
    return null;
  }
}

MatchCardInfoSlider.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  isWapView: PropTypes.bool,
  isLanding: PropTypes.bool,
  slideToShow: PropTypes.string,
  slideToShowSmall: PropTypes.string,
};

MatchCardInfoSlider.defaultProps = {
  items: [],
  isWapView: false,
  isLanding: false,
  slideToShow: '',
  slideToShowSmall: 2.4,
};

export default MatchCardInfoSlider;
